import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ParentDependentSelect from "./ParentDependentSelect";
import ParentDependentMultiSelect from "./ParentDependentMultiSelect";
import translate from '../../services/translation';
import IndependentMultiSelector from "./IndependentMultiSelector";
import ResetButton from "./ResetButton";
import ParentDistrictSelect from "./ParentDistrictSelect";

export default class TravelAreaSelector extends Component {

    static propTypes = {
        countries: PropTypes.array,
        regions: PropTypes.array,
        destinations: PropTypes.array,
        districts: PropTypes.array,
        onChange: PropTypes.func,
        selectedCountry: PropTypes.array,
        selectedRegion: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
        selectedDestination: PropTypes.number,
        selectedDistrict: PropTypes.number,
        fixedTravelAreaLevel: PropTypes.number,
        resetFunction: PropTypes.func,
        hasSpecialIcon: PropTypes.bool,
        disabled: PropTypes.bool,
        listType: PropTypes.string
    };

    render() {
        const {countries, regions, destinations, districts, fixedTravelAreaLevel, selectedCountry, selectedRegion, selectedDestination, selectedDistrict, onChange, resetFunction, hasSpecialIcon, disabled, listType} = this.props;
        return (
            <div className={'plannerFilterElement'}>
                <div className="selectCustom">
                    <IndependentMultiSelector
                        name="travelAreaCountry"
                        defaultOptionLabel={translate('planner_list.choose_country')}
                        options={countries}
                        selectedOptions={selectedCountry}
                        onChange={onChange}
                        disabled={fixedTravelAreaLevel >= 1}
                        hasSpecialIcon={hasSpecialIcon}
                    />
                    {selectedCountry.length > 0 && disabled &&
                        <ResetButton reset={resetFunction} value={selectedCountry} filterKey="travelAreaCountry" />
                    }
                </div>

                <div className="selectCustom">
                    {listType === 'excursion' ? (
                        <ParentDependentMultiSelect
                            name="travelAreaRegion"
                            defaultOptionLabel={translate('planner_list.choose_region')}
                            options={regions}
                            selectedOptions={selectedRegion}
                            selectedParents={selectedCountry}
                            onChange={this.props.onChange}
                            disabled={fixedTravelAreaLevel >= 2}
                            hasSpecialIcon={hasSpecialIcon}
                            resetFunction={resetFunction}
                        />
                    ) : (
                        <ParentDependentSelect
                            name="travelAreaRegion"
                            defaultOptionLabel={translate('planner_list.choose_region')}
                            options={regions}
                            selectedOption={selectedRegion}
                            selectedParent={selectedCountry}
                            onChange={this.props.onChange}
                            disabled={fixedTravelAreaLevel >= 2}
                            hasSpecialIcon={hasSpecialIcon}
                        />
                    )}
                    {(Array.isArray(selectedRegion) ? selectedRegion.length > 0 : !!selectedRegion) &&
                        <ResetButton reset={resetFunction} value={selectedRegion} filterKey="travelAreaRegion" />
                    }
                </div>

                <div className="selectCustom">
                    <ParentDependentSelect
                        name="travelAreaDestination"
                        defaultOptionLabel={translate('planner_list.choose_destination')}
                        options={destinations}
                        selectedOption={selectedDestination}
                        selectedParent={selectedRegion}
                        onChange={this.props.onChange}
                        disabled={fixedTravelAreaLevel === 3}
                        hasSpecialIcon={hasSpecialIcon}
                    />
                    {selectedDestination !== '' &&
                        <ResetButton reset={resetFunction} value={selectedDestination} filterKey="travelAreaDestination" />
                    }
                </div>


                {listType === 'excursion' &&
                    <div className="selectCustom">
                        <ParentDistrictSelect
                            name='travelAreaDistrict'
                            defaultOptionLabel={translate('planner_list.choose_district')}
                            options={districts}
                            selectedOption={selectedDistrict}
                            selectedParent={selectedDestination}
                            onChange={this.props.onChange}
                            hasSpecialIcon={hasSpecialIcon}
                        />
                        {selectedDistrict !== '' &&
                            <ResetButton reset={resetFunction} value={selectedDistrict} filterKey="travelAreaDistrict"/>
                        }
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Planner/TravelAreaSelector.js